import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PermissionList from "./components/PermissionList";

export default store => ({
  path: "roles-and-permissions",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "behaviour-roles-and-permissions" */ "./components"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [PermissionList(store)],
});
